import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import API_URL from '../api/baseURL';

const ViewMaintenance = () => {
  const { id } = useParams(); // log id
  const { token, user } = useAuth();
  const navigate = useNavigate();
  const [log, setLog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    const fetchLog = async () => {
      try {
        const res = await axios.get(`${API_URL}/maintenance/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setLog(res.data);
      } catch (e) {
        setErr(e.message);
      } finally {
        setLoading(false);
      }
    };
    fetchLog();
  }, [id, token]);

  // Redirect based on user role
  const getDashboardPath = () => {
    if (!user) return '/login';
    switch ((user.role || '').toLowerCase()) {
      case 'car owner': return '/dashboard';
      case 'car workshop': return '/workshop';
      case 'spare parts supplier': return '/supplier';
      case 'insurance company': return '/insurance';
      case 'vehicle loader': return '/loader';
      case 'admin': return '/admin/part-validations';
      default: return '/dashboard';
    }
  };

  const handleAction = async (action) => {
    try {
      await axios.patch(`${API_URL}/maintenance/${action}/${id}`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert(`Log ${action}ed successfully.`);
      navigate(getDashboardPath());
    } catch (e) {
      alert(`Failed to ${action} log: ${e.response?.data?.error || e.message}`);
    }
  };

  if (loading) return <p className="text-[#6E665C]">Loading log...</p>;
  if (err) return <p className="text-red-500">Error: {err}</p>;
  if (!log) return <p className="text-[#8F877B]">No log found</p>;

  return (
    <div className="max-w-xl mx-auto bg-[#17140F] dark:bg-[#17140F] p-6 rounded shadow mt-6">
      <h2 className="text-xl font-bold mb-4 text-blue-600">Maintenance Log Details</h2>
      <div className="space-y-2 text-sm text-[#F4F1EA] text-[#F4F1EA]">
        <p><strong>Vehicle:</strong> {log.vehicleId?.plateNumber || 'Unknown'}</p>
        <p><strong>Description:</strong> {log.description}</p>
        <p><strong>Service Reason:</strong> {log.serviceReason}</p>
        <p><strong>Date:</strong> {new Date(log.date).toLocaleDateString()}</p>
        <p><strong>Technician:</strong> {log.technician}</p>
        <p><strong>Total Cost:</strong> {log.totalCost}€</p>
        <p><strong>Status:</strong> {log.status}</p>
      </div>

      {log.status === 'pending' && (
        <div className="flex gap-4 mt-6">
          <button
            onClick={() => handleAction('confirm')}
            className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
          >
            Confirm
          </button>
          <button
            onClick={() => handleAction('reject')}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            Reject
          </button>
        </div>
      )}
    </div>
  );
};

export default ViewMaintenance;
